import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
  faUsersCog,
  faBuilding,
  faUserShield,
  faUser,
  faEnvelope,
  faKey,
  faMapMarkerAlt,
  faPhone,
  faGlobe,
  faArrowLeft,
  faPlusCircle,
  faExclamationCircle,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '../../../../../services/auth/auth.service';

@Component({
  selector: 'app-register-company',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule
  ],
  templateUrl: './register-company.component.html',
  styleUrls: ['./register-company.component.scss']
})
export class RegisterCompanyComponent implements OnInit {
  // FontAwesome icons
  faUsersCog = faUsersCog;
  faBuilding = faBuilding;
  faUserShield = faUserShield;
  faUser = faUser;
  faEnvelope = faEnvelope;
  faKey = faKey;
  faMapMarkerAlt = faMapMarkerAlt;
  faPhone = faPhone;
  faGlobe = faGlobe;
  faArrowLeft = faArrowLeft;
  faPlusCircle = faPlusCircle;
  faExclamationCircle = faExclamationCircle;
  faCheckCircle = faCheckCircle;

  registerForm: FormGroup;
  isLoading: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';
  adminUsername: string = '';
  companyName: string = '';

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService
  ) {
    this.registerForm = this.fb.group({
      adminUsername: ['', [Validators.required, Validators.minLength(3)]],
      adminEmail: ['', [Validators.required, Validators.email]],
      adminPassword: ['', [Validators.required, Validators.minLength(6)]],
      companyName: ['', [Validators.required]],
      companyAddress: [''],
      companyPhone: [''],
      companyEmail: ['', [Validators.email]],
      companyWebsite: ['']
    });
  }

  ngOnInit(): void {
    // Check if user is a superuser
    this.checkSuperuserAccess();
  }

  onSubmit() {
    if (this.registerForm.invalid) {
      // Mark all fields as touched to trigger validation messages
      Object.keys(this.registerForm.controls).forEach(key => {
        this.registerForm.get(key)?.markAsTouched();
      });
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.successMessage = '';

    const formData = {
      admin: {
        username: this.registerForm.get('adminUsername')?.value,
        email: this.registerForm.get('adminEmail')?.value,
        password: this.registerForm.get('adminPassword')?.value
      },
      company: {
        name: this.registerForm.get('companyName')?.value,
        address: this.registerForm.get('companyAddress')?.value,
        phone: this.registerForm.get('companyPhone')?.value,
        email: this.registerForm.get('companyEmail')?.value,
        website: this.registerForm.get('companyWebsite')?.value
      }
    };

    this.http.post('/api/admin/register', formData).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.adminUsername = formData.admin.username;
        this.companyName = formData.company.name;
        this.successMessage = 'Registration successful!';
        
        // Reset form after successful registration
        this.registerForm.reset();
      },
      error: (error) => {
        this.isLoading = false;
        this.errorMessage = error.error.message || 'Registration failed. Please try again.';
      }
    });
  }

  checkSuperuserAccess(): void {
    // First check local storage data
    const isSuperuser = this.authService.isSuperuser();
    
    // Then verify with API
    this.authService.checkSuperuser().subscribe(isSuperuser => {
      if (!isSuperuser) {
        this.errorMessage = 'You do not have superuser permissions to register companies.';
        this.router.navigate(['/hr/admin']);
      }
    });
  }
} 